// src/pages/ListeningPreviewPage.jsx
import { useNavigate } from "react-router-dom";
import {ListeningBigIcon} from "../../../assets"; 
import { ArrowLeft } from "lucide-react";

const ListeningPreviewPage = () => {
  const navigate = useNavigate();

  const handleBackToCategory = () => {
    navigate("/IELTSTest");
  };

  const handleStartTest = () => {
    navigate("/listening/soal");
  };

  return (
    <section className="min-h-screen bg-gradient-to-b from-[#E0E7FF] to-white py-6 px-4 sm:py-8 md:py-12 lg:py-16 flex items-center justify-center">
      <div className="w-full max-w-6xl mx-auto">
        {/* Card Utama */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl lg:shadow-2xl overflow-hidden flex flex-col md:flex-row min-h-[400px] md:min-h-[450px] lg:min-h-[500px]">
          {/* === BAGIAN KIRI: Informasi Tes === */}
          <div className="bg-gradient-to-r from-[#1e3e7e] to-[#a51c30] p-4 sm:p-6 md:p-8 lg:p-10 xl:p-12 flex flex-col justify-between text-white w-full md:w-1/2 overflow-y-auto">
            <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6">
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-3xl font-bold font-poppins">
                INFORMASI TES
              </h2>

              <ul className="text-[10px] xs:text-xs sm:text-xs md:text-sm lg:text-sm font-roboto space-y-1 list-disc list-inside leading-tight">
                <li>Jumlah Soal: 40 Pertanyaan</li>
                <li>Durasi: 30 Menit</li>
                <li>Terdiri dari 4 bagian dengan rekaman audio berbeda</li>
                <li>
                  Jenis soal: Multiple Choice, True/False, Fill in the Blank,
                  dll.
                </li>
              </ul>

              <h3 className="text-base sm:text-lg md:text-xl lg:text-xl xl:text-2xl font-semibold font-poppins mt-3 sm:mt-4">
                PANDUAN MENGERJAKAN:
              </h3>
              <ul className="text-[10px] xs:text-xs sm:text-xs md:text-sm lg:text-sm font-roboto space-y-1 list-disc list-inside leading-tight">
                <li>Gunakan headphone untuk hasil terbaik</li>
                <li>Baca pertanyaan sebelum audio diputar</li>
                <li>Perhatikan kata kunci dalam rekaman</li>
                <li>Jawab semua soal, tidak ada pengurangan nilai</li>
              </ul>

              <div className="bg-red-600 text-white p-2.5 sm:p-3 md:p-4 lg:p-5 xl:p-6 rounded-lg sm:rounded-xl text-[10px] xs:text-xs sm:text-xs md:text-sm lg:text-sm font-roboto mt-4 leading-tight">
                <p className="font-bold mb-1">PERHATIAN!</p>
                <p>
                  Setelah kamu menekan tombol <strong>"Mulai Tes"</strong>,
                  waktu akan <strong>langsung berjalan</strong> dan{" "}
                  <strong>tidak dapat dihentikan</strong>. Pastikan kamu sudah
                  siap!
                </p>
              </div>
            </div>

            <button
              onClick={handleBackToCategory}
              className="mt-4 sm:mt-6 md:mt-8 lg:mt-10 bg-transparent border-2 border-white text-white font-poppins font-semibold text-xs sm:text-sm md:text-base lg:text-lg px-4 sm:px-5 md:px-6 lg:px-7 py-2 sm:py-2.5 md:py-3 rounded-full hover:bg-white hover:text-[#1e3e7e] transition flex items-center gap-1.5 sm:gap-2 w-fit"
            >
              <ArrowLeft size={16} className="sm:size-5 md:size-6 lg:size-6" />
              Kembali
            </button>
          </div>

          {/* === BAGIAN KANAN: Preview Icon === */}
          <div className="bg-white p-4 sm:p-6 md:p-8 lg:p-10 xl:p-12 flex flex-col justify-between text-center w-full md:w-1/2">
            <div className="space-y-4 sm:space-y-5 md:space-y-6 lg:space-y-8 flex-1 flex flex-col justify-center items-center">
              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl font-bold text-[#1e3e7e] font-poppins">
                LISTENING TEST
              </h1>

              <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-40 lg:h-40 xl:w-48 xl:h-48 bg-none flex items-center justify-center p-3 sm:p-4 md:p-5 lg:p-6">
                <img
                  src={ListeningBigIcon}
                  alt="Listening Icon"
                  className="w-full h-full object-contain"
                />
              </div>

              <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl text-gray-700 font-roboto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg leading-relaxed">
                Persiapkan dirimu sebelum memulai simulasi test ini.
              </p>
            </div>

            <div className="flex justify-end mt-4 sm:mt-6 md:mt-8 lg:mt-10">
              <button
                onClick={handleStartTest}
                className="bg-yellow-400 text-[#1e3e7e] font-poppins font-bold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl px-5 sm:px-6 md:px-7 lg:px-8 py-2 sm:py-2.5 md:py-3 lg:py-3.5 rounded-full hover:bg-yellow-500 transition shadow-md"
              >
                Mulai Test
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ListeningPreviewPage;
